import React from "react";

export function Spacer() {
  return <div className="spacer" />;
}
